// Spec 27 PR 2b — SuggestionChips widget.
//
// Inline row of pill chips. Clicking a chip emits a "pick" action
// with the chosen id. State machine: idle until clicked; then the
// surface drives submitting → succeeded → trace.

import { Pill } from "@/components/glass";

import type { WidgetRenderProps } from "../registry";

interface SuggestionChipsProps {
	prompt?: string | null;
	chips: { id: string; label: string }[];
}

export function SuggestionChips({
	props,
	state,
	onAction,
}: WidgetRenderProps<SuggestionChipsProps>) {
	const submitting = state.kind === "submitting";
	const succeededValues =
		state.kind === "succeeded" ? (state.result as { id: string }) : null;

	// Trace state: compress to a thin line showing the choice.
	if (state.kind === "succeeded" && succeededValues) {
		const chosen = props.chips.find((c) => c.id === succeededValues.id);
		return (
			<div className="text-center text-[12px] text-[var(--color-text-muted)] py-1">
				<span className="text-[var(--color-success)] mr-1.5">✓</span>
				{chosen?.label ?? succeededValues.id}
			</div>
		);
	}

	return (
		<div
			className="text-center space-y-4 py-3"
			style={{ opacity: submitting ? 0.65 : 1 }}
		>
			{props.prompt && (
				<div className="text-[14px] text-[var(--color-text)]">
					{props.prompt}
				</div>
			)}
			<div className="flex flex-wrap justify-center gap-2">
				{props.chips.map((chip) => (
					<Pill
						key={chip.id}
						onClick={() =>
							!submitting && onAction("pick", { id: chip.id })
						}
						disabled={submitting}
					>
						{chip.label}
					</Pill>
				))}
			</div>
		</div>
	);
}
